import { useSnackbar } from '@/features/snackbar';
import { VariablesOf } from 'gql.tada';
import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';

const MUTATION = gql(
  `
  mutation UpdateNarrative($input: UpdateNarrativeInput!) {
    updateNarrative(input: $input) {
      companyId
    }
  }
`
);

const useUpdatePublicNarrativeBase = makeGqlMutation(MUTATION);

type Variables = VariablesOf<typeof MUTATION>;

interface Props {
  onSuccess: () => void;
}

export const useUpdatePublicNarrative = ({ onSuccess }: Props) => {
  const { addSnackbar } = useSnackbar();

  return useUpdatePublicNarrativeBase({
    onSuccess: async () => {
      onSuccess();
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Successfully updated narrative',
      });
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to update narrative',
      });
    },
  });
};

export type UpdateNarrativeInput = Variables['input'];
export type UpdateValuationInput = NonNullable<
  UpdateNarrativeInput['valuations']
>[number];
export type UpdateContentBlockInput = NonNullable<
  UpdateNarrativeInput['contentBlocks']
>[number];
